import React                  from 'react';
import { withStyles }         from '@material-ui/core/styles';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import {colores}              from '../global'
import AuthService            from '../AuthService';
import AppBar from '../../node_modules/@material-ui/core/AppBar';
import Tooltip from '../../node_modules/@material-ui/core/Tooltip';
import Toolbar from '../../node_modules/@material-ui/core/Toolbar';
import Icono from './Icono'
import Button from '@material-ui/core/Button';
//import { IconButton } from '@material-ui/core';

const theme = createMuiTheme({
    palette: {
      //type: 'dark',
      secondary: {
          main: colores.naranja
        },
        primary: {
          main: colores.tabla.encabezado//colores.azul
        }
      },
      overrides: {            
         MuiTooltip:{
          tooltip:{
            fontSize: 12
           }
         }       
      },
    },
  )

  var movil_pequeño=/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

   /*                           CLASES DE ESTILO                       */

var styles = theme =>({
  button: {
    margin: movil_pequeño?3:theme.spacing(1),
    paddingRight: theme.spacing(2),
    alignItems: 'center',
   // boxShadow: 'unset grey 1px 1px 3px 1px',
    boxShadow: '0px 0px 1px 2px rgba(179,179,179,0.5);-webkit-box-shadow: 0px 1px 1px 1px rgba(179,179,179,0.5);-moz-box-shadow: 0px 0px 2px 1px rgba(179,179,179,1);',
    border: 'none',
    borderRadius:2,
  },
  iconSizeSmall:{
    '& > *:first-child': {fontSize: 17}
  },

})

  /*                                      EXPORT                                 */
export default withStyles(styles)(
    class Barra_menu extends React.Component {
        tablaRef = React.createRef();
    constructor(props) {
    super(props);
     this.Auth = new AuthService();
     this.l = props.l
     this.e = props.e
     this.i = props.i
     this.align=props.align===undefined?'center':props.align
     this.botones=props.botones
     this.backgroundColor=props.backgroundColor
     this.borderRadius_barra=props.borderRadius_barra
     this.width_barra=props.width_barra
     this.marginBottom_barra = props.marginBottom_barra
     this.marginTop_barra = props.marginTop_barra
     this.color_barra = props.color_barra
     this.boxShadow_barra = props.boxShadow_barra
     this.display_barra = props.display_barra
  
     this.state = {
     };

    };//FIN CONSTRUCTOR

  shouldComponentUpdate(nextprops,nextstate){
    if(nextprops.botones!==this.props.botones)
    return true;

    return false
  }
  
  render() {
        const { classes,botones,l,e,i,align,backgroundColor,borderRadius_barra,width_barra,marginBottom_barra,marginTop_barra,color_barra,boxShadow_barra,display_barra } = this.props;
        this.botones = botones
        this.l = l
        this.e = e
        this.i = i
        this.align=align===undefined?'center':align
        this.backgroundColor=backgroundColor
        this.borderRadius_barra=borderRadius_barra
        this.width_barra=width_barra
        this.marginBottom_barra = marginBottom_barra
        this.marginTop_barra = marginTop_barra
        this.color_barra = color_barra
        this.boxShadow_barra = boxShadow_barra
        this.display_barra = display_barra

        return (
          <MuiThemeProvider theme={theme}>
            <div align="center" style={{background:'transparent' ,overflowX: 'hidden',display:this.display_barra===undefined?'auto':this.display_barra}}> 
                
              <AppBar color= {this.color_barra===undefined?'inherit':this.color_barra } 
              style={{width: this.width_barra===undefined?'100%':this.width_barra,marginBottom: this.marginBottom_barra===undefined?0:this.marginBottom_barra
                ,marginTop: this.marginTop_barra===undefined?0:this.marginTop_barra,borderRadius: this.borderRadius_barra===undefined?0:this.borderRadius_barra
                //,backgroundColor: this.backgroundColor
                ,alignItems: this.align, position: 'relative', 
                //boxShadow: this.boxShadow_barra===undefined?'none':this.boxShadow_barra,
                padding:0,display: this.display_barra===undefined?'auto':this.display_barra
                }}>
                <Toolbar variant="dense" 
                >
                  <div align="center" style={{width:'100%'}}>
                  {this.botones.map((item,index,array) =>{
                    var disa = item.escritura===undefined?item.impresion===undefined?false:item.impresion?this.i===false?true:false:false:item.escritura?this.e===false?true:item.disabled?item.disabled:false:item.disabled?item.disabled:false
                    var boton =movil_pequeño?  <Button key={'Button-'+index.toString()} variant='text' //variant={item.variant===undefined?"contained":item.variant}
                    color='primary' 
                    size="small"
                    onClick={item.onclick} disabled={disa}
                    className={classes.button} 
                    classes={{iconSizeSmall: classes.iconSizeSmall }}
                    startIcon={<Icono fontSize='small' icono={item.icono} style={{display:item.nombre==='' || item.nombre===undefined?'none':'auto'}} />}
                    style={{padding:5,textTransform: 'none',display:item.display,color:item.color// backgroundColor:item.color
                    ,marginLeft: item.marginLeft===undefined?index===0?0:item.marginLeft:item.marginLeft,marginRight:item.marginRight===undefined?array.length-1===index?0:item.marginRight:item.marginRight
                    }}
                  >
                    {item.nombre===''||item.nombre===undefined?<Icono fontSize='small' icono={item.icono} />:null}
                    {item.nombre}
                  </Button>
                    :
                    <Button key={'Button-'+index.toString()} variant='text' //variant={item.variant===undefined?"contained":item.variant}
                    color='primary' 
                    size="small"
                    onClick={item.onclick} disabled={disa}
                    className={classes.button} 
                    classes={{iconSizeSmall: classes.iconSizeSmall }}
                    startIcon={<Icono fontSize='small' icono={item.icono} style={{display:item.nombre==='' || item.nombre===undefined?'none':'auto'}} />}
                    style={{textTransform: 'none',display:item.display,color:item.color// backgroundColor:item.color
                    ,marginLeft: item.marginLeft===undefined?index===0?0:item.marginLeft:item.marginLeft,marginRight:item.marginRight===undefined?array.length-1===index?0:item.marginRight:item.marginRight
                    }}
                  >
                    {item.nombre===''||item.nombre===undefined?<Icono fontSize='small' icono={item.icono} />:null}
                    {item.nombre}
                  </Button>
                  if(disa===false)
                    return(
                      <Tooltip key={'Tooltip-'+index.toString()} title={item.toolt===undefined?'':item.toolt} PopperProps={{style:{zIndex:500000}}} 
                      style={{display: item.toolt===undefined?'none':'auto'}}> 
                        {boton}
                      </Tooltip>
                    )
                  else
                    return( 
                        boton
                    )
                  })
                  }
                  </div>
                </Toolbar>
              </AppBar>
            </div>
            </MuiThemeProvider>
        );
    } /// finaliza render
} /// finaliza class
)/// finaliza withStyles